/* global Swiper */
// *******************************************************************************
// 1.0 - count block slider
// *******************************************************************************

const CountBlockSliderElements = document.querySelectorAll('[data-slider="count-slider"]');

const CountBlockSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 10,
  autoHeight: true,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1023: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
};

CountBlockSliderElements.forEach((el) => {
  const CountBlockSliderParent = el.closest('.sc-count-slider');
  const arrowRight = CountBlockSliderParent.querySelectorAll('.arrow-right')[0];
  const arrowLeft = CountBlockSliderParent.querySelectorAll('.arrow-left')[0];

  CountBlockSliderOptions.navigation.nextEl = arrowRight;
  CountBlockSliderOptions.navigation.prevEl = arrowLeft;

  // eslint-disable-next-line no-unused-vars
  const CountBlockSlider = new Swiper(el, CountBlockSliderOptions);
});
